import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/components/feature/PostCard";
import { allPosts, getLatestPosts } from "@/lib/content";

export default function EditorPick() {
  const main = allPosts[1];
  const latest = getLatestPosts(5);

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="EDITOR'S PICK"
          title="本周编辑精选"
          description="不追热度，只挑那些看完之后心情会变好一点的内容，全部经过人工整理与点评。"
          actionLabel="查看全部栏目"
          actionTo="/category/mingchangmian"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            {main && <PostCard post={main} variant="wide" />}
          </div>

          <aside className="lg:col-span-4">
            <div className="flex h-full flex-col rounded-xl2 border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">最新更新</h3>
                <span className="flex items-center gap-1 text-xs text-secondary-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-secondary-500"></span>
                  实时
                </span>
              </div>
              <div className="mt-3 flex-1 divide-y divide-background-200">
                {latest.map((post) => (
                  <PostCard key={post.id} post={post} variant="compact" />
                ))}
              </div>
              <div className="mt-4 rounded-lg bg-accent-50 px-4 py-3">
                <p className="text-xs leading-relaxed text-accent-900">
                  <strong className="font-medium">下次更新时间：</strong>
                  每天晚上 8 点前后，四个栏目会同步补充新的内容。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}